module.exports = __webpack_public_path__ + "assets/img/indoor.3b95196b.png";